module.exports = __webpack_public_path__ + "files/2938c07993ceb05e426a2687bff8ae91.png";